<template>
  <text-box :label="titleString" :icon="icon" :hideTitle="hideTitle" :elevation="elevation">
      <template v-slot:info-dialog>
        <slot name="info-dialog"></slot>
      </template>
      <template v-slot:info>
        <slot name="info"></slot>
      </template>
      <v-container fluid>
        <v-row v-if="showSelector">
          <v-col cols="6"></v-col>
          <v-col cols="6">
            <v-select
              v-model="selectedSeriesInternal"
              :items="channelKeys"
              label="Channel"
              multiple
              chips
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 1">
                  <span>{{ item }}</span>
                </v-chip>
                <span
                  v-if="index === 1"
                  class="text-grey text-caption align-self-center"
                >
                  (+{{ selectedSeriesInternal.length - 1 }} others)
                </span>
              </template>
              <template v-slot:prepend-item>
                <v-list-item
                  ripple
                  @mousedown.prevent
                  @click="toggle"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $t('components.simulationDetails.ChannelCurvesChartMulti.selectAll') }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
            </v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <channel-curves-chart-multi-instance v-if="!(showSelector && selectedSeries.length === 0)" v-bind="$props" :only="selectedSeries"/>
          </v-col>
        </v-row>
      </v-container>
  </text-box>
</template>

<script>
import TextBox from '@/components/TextBox.vue'
import ChannelCurvesChartMultiInstance from '@/components/simulationDetails/ChannelCurvesChartMultiInstance.vue'
export default {
  data () {
    return {
      selectedSeriesInternal: [],
      selectedSeries: []
    }
  },
  methods: {
    toggle () {
      this.selectedSeries = []
      this.$nextTick(() => {
        if (this.selectedSeriesInternal.length !== this.channelKeys.length) {
          this.selectedSeriesInternal = this.channelKeys.slice()
          this.selectedSeries = this.selectedSeriesInternal
        } else {
          this.selectedSeriesInternal = []
        }
      })
    }
  },
  computed: {
    /* onlyShow () {
      let x = []
      if (this.selectedSeries && this.selectedSeries !== ' All') {
        x.push(this.selectedSeries)
      }
      return x
    }, */
    channelKeys: function () {
      // return [' All', ...Object.keys(this.data)]
      return [...Object.keys(this.data)]
    }
  },
  watch: {
    selectedSeriesInternal (value) {
      this.selectedSeries = []
      this.$nextTick(() => {
        this.selectedSeries = this.selectedSeriesInternal
      })
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    colors: {
      type: [Object, Array],
      required: false
    },
    titleString: {
      type: String,
      required: false,
      default: function () {
        return ''
      }
    },
    exportImageName: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      required: false,
      default: function () {
        return ''
      }
    },
    xName: {
      type: String,
      required: false
    },
    yName: {
      type: String,
      required: false
    },
    secondaryYName: {
      type: String,
      required: false,
      default: null
    },
    showDiagonal: {
      type: Boolean,
      required: false
    },
    showNegatives: {
      type: Boolean,
      required: false
    },
    lineStyles: {
      type: String,
      required: false
    },
    xAxisTypeIsCategory: {
      type: Boolean,
      required: false
    },
    xAxisTypeIsDate: {
      type: Boolean,
      required: false
    },
    xAxisRotate: {
      type: Number,
      required: false
    },
    gridBottomMargin: {
      type: Number,
      required: false,
      default () {
        return 30
      }
    },
    export: {
      type: Boolean,
      required: false,
      default: function () {
        return false
      }
    },
    legendOrient: {
      type: String,
      required: false,
      default: function () {
        return 'vertical'
      }
    },
    legendBottom: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    },
    animation: {
      type: Boolean,
      required: false,
      default () {
        return true
      }
    },
    showLegend: {
      type: Boolean,
      required: false,
      default () {
        return true
      }
    },
    hideTitle: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    },
    showSelector: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    },
    dataPointNames: {
      type: Array,
      required: false,
      default () {
        return []
      }
    },
    showDataZoom: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    },
    scale: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    },
    filterMode: {
      type: String,
      required: false,
      default () {
        return 'none'
      }
    },
    elevation: {
      type: String,
      required: false,
      default () {
        return 'elevation-2'
      }
    },
    hideDatapoints: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    },
    showTooltips: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    },
    smoothLines: {
      type: Boolean,
      required: false,
      default () {
        return true
      }
    },
    detailedTooltip: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    },
    tooltipSignificantDecimals: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    },
    tooltipValueMantissa: {
      type: Number,
      required: false,
      default () {
        return 1
      }
    },
    showQuarters: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    },
    period: {
      type: String,
      required: false,
      default () {
        return ''
      }
    },
    nameTranslations: {
      type: Object,
      required: false,
      default: function () {
        return {}
      }
    },
    // The series whose four region boundaries shade the plot. Needed only when a chart draws more
    // than one series OF THE SAME CHANNEL: the default rule below — shade a chart that carries a
    // single curve — cannot tell that case apart from several channels overlaid, where one channel's
    // zones painted across all of them would be read as everybody's.
    regionsChannel: {
      type: String,
      required: false,
      default: null
    },
    // BOTH AXES ON ONE RANGE, for a chart whose x and y are the same quantity. A saturation curve is
    // dollars against dollars — what a channel is given and what it gives back — and two independent
    // auto-scales lay two rulers of different lengths on one thing: a channel returning half what it
    // costs and one returning three times it draw the same shape, each filling its own box, and
    // neither picture says which it is. Given this, both axes run to the larger of the two maxima.
    // Off by default, and every existing caller is untouched: a chart of spend against share, or of
    // anything against months, has two axes that cannot be compared and must not be.
    sameAxisScale: {
      type: Boolean,
      required: false,
      default: false
    },
    // AXES WITH NO FIGURES ON THEM. A chart whose numbers do not mean anything yet — a curve
    // standing on a placeholder scale, waiting for the two figures that put it in somebody's own
    // money — is still a picture of a SHAPE, and the shape is worth drawing. What is not worth
    // drawing is the ruler beside it: a reader who takes 0.6 off an axis has read a number this
    // chart never claimed. The axis, its name and its grid stay; the values go.
    hideAxisValues: {
      type: Boolean,
      required: false,
      default: false
    },
    showDifference: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    },
    differenceLabel: {
      type: String,
      required: false,
      default () {
        return ''
      }
    }
  },
  components: {
    TextBox,
    ChannelCurvesChartMultiInstance
  }
}
</script>
